module.exports = __webpack_public_path__ + "img/file.66ef7a3a.svg";